import api from './api';
// 获得产品列表
export function viewProductInfo(params) {
  return api.post('/product/getHome', params, true, false).then(res => res);
}

// 获得产品列表
export function viewProductByID(params) {
  return api.post('/product/info', params, true, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/frontProduct.js